import { render } from "./MyAccountProfilePage.vue?vue&type=template&id=76aaac54"
import script from "./MyAccountProfilePage.vue?vue&type=script&lang=js"
export * from "./MyAccountProfilePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__